import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header-section" }
const _hoisted_2 = {
  key: 0,
  class: "landing-nav"
}
const _hoisted_3 = { class: "open-layout app-shell__body" }
const _hoisted_4 = { class: "sidebar-item" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = { class: "sidebar-item" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = {
  key: 0,
  class: "title"
}
const _hoisted_10 = { class: "sidebar-item" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = {
  key: 0,
  class: "title"
}
const _hoisted_13 = { class: "sidebar-item" }
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = {
  key: 0,
  class: "title"
}
const _hoisted_16 = { class: "sidebar-item" }
const _hoisted_17 = { class: "icon" }
const _hoisted_18 = {
  key: 0,
  class: "title"
}
const _hoisted_19 = { class: "sidebar-item" }
const _hoisted_20 = { class: "icon" }
const _hoisted_21 = {
  key: 0,
  class: "title"
}
const _hoisted_22 = { class: "sidebar-item" }
const _hoisted_23 = { class: "icon" }
const _hoisted_24 = {
  key: 0,
  class: "title"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "sidebar-item" }
const _hoisted_27 = { class: "icon" }
const _hoisted_28 = {
  key: 0,
  class: "title"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "sidebar-item" }
const _hoisted_31 = { class: "icon" }
const _hoisted_32 = {
  key: 0,
  class: "title"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "main app-shell__main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_brand_logo = _resolveComponent("app-brand-logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_option = _resolveComponent("app-option")!
  const _component_app_dropdown = _resolveComponent("app-dropdown")!
  const _component_app_burger_menu = _resolveComponent("app-burger-menu")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_sidebar = _resolveComponent("app-sidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container app-shell", { 'is-landing': _ctx.isLanding }])
  }, [
    _createVNode(_component_app_header, null, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createVNode(_component_router_link, {
            class: "brand-link",
            to: "/home"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_app_brand_logo)
            ]),
            _: 1
          }),
          _createElementVNode("section", null, [
            (_ctx.isLanding && !_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
                  _createVNode(_component_router_link, { to: "/consultation" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('consultation')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/FAQ" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('FAQ')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/contacts" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('contacts')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/signIn" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('login')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    class: "nav-cta",
                    to: "/signUp"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('signUp')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_app_dropdown, {
              modelValue: _ctx.language,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.language) = $event)),
              label: "name"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (item) => {
                  return (_openBlock(), _createBlock(_component_app_option, {
                    key: item,
                    value: item
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_app_burger_menu, {
                  key: 1,
                  landing: _ctx.isLanding
                }, null, 8, ["landing"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_3, [
      (!_ctx.isLanding || _ctx.isMobile)
        ? (_openBlock(), _createBlock(_component_app_sidebar, {
            key: 0,
            landing: _ctx.isLanding
          }, {
            main: _withCtx(({ isShort }) => [
              _createVNode(_component_router_link, {
                to: "/home",
                "active-class": "active-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "xl",
                        icon: ['fas', 'home']
                      })
                    ]),
                    (!isShort)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.t('home')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_router_link, {
                to: "/consultation",
                "active-class": "active-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "xl",
                        icon: ['fas', 'user-tie']
                      })
                    ]),
                    (!isShort)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.t('consultation')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_router_link, {
                to: "/FAQ",
                "active-class": "active-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "xl",
                        icon: ['fas', 'question-circle']
                      })
                    ]),
                    (!isShort)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.t('FAQ')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_router_link, {
                to: "/contacts",
                "active-class": "active-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "xl",
                        icon: ['fas', 'contact-card']
                      })
                    ]),
                    (!isShort)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.t('contacts')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_router_link, {
                to: "/signIn",
                "active-class": "active-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "xl",
                        icon: ['fas', 'sign-in']
                      })
                    ]),
                    (!isShort)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.t('login')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_router_link, {
                to: "/signUp",
                "active-class": "active-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "xl",
                        icon: ['fas', 'user-plus']
                      })
                    ]),
                    (!isShort)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.t('signUp')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_router_link, {
                to: "/account/delete",
                "active-class": "active-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "xl",
                        icon: ['fas', 'trash']
                      })
                    ]),
                    (!isShort)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.t('accountDeleteTitle')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("a", {
                href: _ctx.privacyUrl,
                target: "_blank",
                rel: "noopener"
              }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_font_awesome_icon, {
                      size: "xl",
                      icon: ['fas', 'shield-halved']
                    })
                  ]),
                  (!isShort)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.t('privacyPolicy')), 1))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_25),
              _createElementVNode("a", {
                href: _ctx.termsUrl,
                target: "_blank",
                rel: "noopener"
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_font_awesome_icon, {
                      size: "xl",
                      icon: ['fas', 'file-lines']
                    })
                  ]),
                  (!isShort)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.t('termsOfService')), 1))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_29)
            ]),
            additional: _withCtx(({ isShort, toggle }) => [
              (!_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "sidebar-item",
                    onClick: toggle
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      size: "xl",
                      icon: isShort ? ['fas', 'arrow-left'] : ['fas', 'arrow-right']
                    }, null, 8, ["icon"])
                  ], 8, _hoisted_33))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["landing"]))
        : _createCommentVNode("", true),
      _createElementVNode("main", _hoisted_34, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 2))
}